angular.module('unergie.main')
.directive('jsonmodel', () =>
    ({
        require: 'ngModel',
        link(scope, element, attrs, ngModelController) {
            ngModelController.$parsers.push((data) => {
                try {
                    return JSON.parse(data)
                } catch (error) {
                    return data
                }
            })

            return ngModelController.$formatters.push((data) => {
                try {
                    return JSON.stringify(data)
                } catch (error) {
                    return data
                }
            })
        },
    }),
)
